import { apiFetch } from "../utils/api";

export const incidentsService = {

  async create(data) {
    return apiFetch('/api/incidents', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
  },

  async update(id, data) {
    return apiFetch(`/api/incidents/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
  },

  async resolve(id, observations) {
    return apiFetch(`/api/incidents/${id}/resolve`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ observations })
    });
  },

  async reopen(id) {
    return apiFetch(`/api/incidents/${id}/reopen`, {
      method: 'POST'
    });
  }

};
